"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useScrollPosition", {
  enumerable: true,
  get: function get() {
    return _useScrollPosition.useScrollPosition;
  }
});

var _useScrollPosition = require("./useScrollPosition");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@n8tb1t/use-scroll-position/lib/index.js
// module id = 224
// module chunks = 0